import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class SettingsBillingCompareRoute extends Route {
	@service('account') declare accountService: Service.Account;
	@service('billing') declare billingService: Service.Billing;
	@service('navigation') declare navigationService: Service.Navigation;

	override beforeModel(): void {
		if (
			this.accountService.isClient ||
			this.billingService.isCanceled ||
			!this.billingService.eligibleForMigration
		) {
			this.navigationService.replaceRoute('settings.billing.index');
		}
	}
}
